import React, { useEffect, useState } from 'react'
import { Layer, Scroller } from 'components'
import Lib from 'library'
import Native from 'library/native'
import styles from 'views/setting/index.module.css'
import MemberEditLayer from 'views/member/MemberEditLayer'
import CertLayer from 'views/setting/cert/CertLayer'
import EventLayer from 'views/setting/EventLayer'
import EventDetailLayer from 'views/setting/EventDetailLayer'
import Notice from 'views/setting/Notice'
import Faq from 'views/setting/Faq'
import AppVer from 'views/setting/AppVer'
import TermsAgree from 'views/setting/TermsAgree'
import AlarmSetting from 'views/setting/AlarmSetting'
import Question from 'views/setting/Question'
import { useSetRecoilState, useRecoilState, useRecoilValue } from 'recoil'
import { showCertLayerState } from 'views/setting/cert/states'
import { showEventLayerState, showNoticeLayerState, showFaqLayerState, showAlarmLayerState, showAppVerLayerState, showTermsAgreeLayerState, showEventDetailLayerState, showQuestionLayerState, pushDataState } from 'views/setting/states'
import { showMemberEditLayerState, showMemberOutReasonLayerState } from 'views/member/states'
import { showSettingState } from 'states/headerState'
import MemberOutReasonLayer from 'views/member/MemberOutReasonLayer'
import useApp from 'hooks/useApp'
import AppInfoFile from 'app_info.json'
// import { useNavigate } from 'react-router-dom'

const SettingHome = () => {
	const App = useApp()

	const setShowMemberEditLayer = useSetRecoilState(showMemberEditLayerState) //내정보변경
	const setShowCertLayer = useSetRecoilState(showCertLayerState)
	const [showEventLayer, setShowEventLayer] = useRecoilState(showEventLayerState) //이벤트
	const setShowEventDetailLayerState = useSetRecoilState(showEventDetailLayerState) //이벤트 상세화면
	const [showNoticeLayer, setShowNoticeLayer] = useRecoilState(showNoticeLayerState) //공지사항
	const setShowFaqLayerState = useSetRecoilState(showFaqLayerState) //FAQ
	const setShowAlarmLayerState = useSetRecoilState(showAlarmLayerState) //알림설정
	const setShowAppVerLayerState = useSetRecoilState(showAppVerLayerState) //앱버전
	const setShowTermsAgreeLayerState = useSetRecoilState(showTermsAgreeLayerState) //약관
	const [showQuestionLayer, setShowQuestionLayer] = useRecoilState(showQuestionLayerState) //문의하기
	const [showSettingLayer, setShowSettingLayer] = useRecoilState(showSettingState)

	const setShowMemberOutReasonLayer = useSetRecoilState(showMemberOutReasonLayerState)

	const [eventList, setEventList] = useState()
	const [eventDetail, setEventDetail] = useState()
	const [eventNewIcon, setEventNewIcon] = useState()

	const [noticeNewIcon, setNoticeNewIcon] = useState()
	const [qnaNewIcon, setQnaNewIcon] = useState() //문의하기 new 아이콘
	const [version, setVersion] = useState(false) //최신버전 비교

	const iosVersion = AppInfoFile.appInfo.ios.currentVer;
	const aosVersion = AppInfoFile.appInfo.android.currentVer;

	// console.log("iosVersion", iosVersion);
	// console.log("aosVersion", iosVersion);

	// 이벤트 리스트 데이터 가져오기
	const getData = () => {
		Lib.get(`/api/more/cstmr/srvc/event`, data => {
			//console.log('[배너EVENT] data : ' + JSON.stringify(data));
			setEventList(data)
		})
	}

	// 이벤트 배너 디테일 화면
	const getDataEventDetail = (id) => {
		Lib.get(`/api/more/cstmr/srvc/event/${id}`, data => {
			//console.log('[배너EVENT상세] data' + JSON.stringify(data));
			setEventDetail(data)
			setShowEventDetailLayerState(true)
		})
	}

	const openWebview = url => {
		Native.execute("AppManager", "openScheme", () => { }, {
			url: url
		})
	}

	//설정메인 new icon 데이터 가져오기
	const getNewIconData = () => {
		Lib.post(`/api/setting/main`, data => {
			setEventNewIcon(data.eventSno)
			setNoticeNewIcon(data.anncmSno)
			setQnaNewIcon(data.inqrySno)
		})
	}

	useEffect(() => {
		if (showSettingLayer === true) {
			getNewIconData()
		}
	}, [showSettingLayer])

	useEffect(() => {
		if (!App.device) return
		const appVersion = App.device.appVersion;
		if (App.device.os.toLowerCase() === "android") { //소문자변환
			setVersion(appVersion !== aosVersion)
		} else {
			setVersion(appVersion !== iosVersion)
		}
	}, [])

	//현재 설치된 앱버전 정보 가져오기 -- DB 에서 가져오기 기능 삭제 2022.10.31 LBJ
	// const getLatestVersion = () => {
	// 	Lib.get("/api/more/app/ver", data => {
	// 		setIos(data.iosAppVer)
	// 		setAos(data.androidAppVer)
	// 	})
	// }

	useEffect(() => {
		if (showSettingLayer) {
			getData()
			// getLatestVersion()
			// 2022.10.28 주의! 경고!
			// Home 에 선언되어 있어 App 전체에 영향이 있기 때문에 App.setShowNav 는 동작하나 여기에서 사용하면 안된다. showSettingLayer 가 아닌 모든페이지에 영향이 가기 때문.
			// App.setShowNav(false); // 하단 바 표여주기 여부: Header에서 컴포넌트를 불러온 상태이기 때문에 최초 로딩은 앱 실행시와 같아, useEffect [] 는 소용이 없음.
			document.querySelector("nav .active")?.classList.remove("active"); // 강제로 제거.
		}
	}, [showSettingLayer])

	//이벤트 배너클릭
	const onEventClick = id => {
		getDataEventDetail(id)
		setShowEventDetailLayerState(true)
	}
	
	return (
		<Layer show={showSettingLayer} closeLayer={() => setShowSettingLayer(false)}
		right={<></>}
		// right={<div className="text-align_right layer-header-text" style={{ fontSize: "1.5rem" }} onClick={() => {
		// 	setShowMemberOutReasonLayer(true)
		// }}>회원탈퇴</div>}
		left={<i className="icon_arrow_back" onClick={() => setShowSettingLayer(false)} />}
		>
			<div className="page">
				<div className="shadow">
					<div className="visual-area pt_30">
						<p className="title">
							{`${App.user?.mbNm}님!`}<br />
							<strong>서비스이용에 꼭 필요한</strong><br />
							내용만 모았어요!
						</p>
						<div className={`${styles["btn-group"]} mt_30`}>
							<span className={styles["btn-group_btn"]} onClick={() => setShowMemberEditLayer(true)}>내 정보 변경</span>
							<span className={styles["btn-group_btn"]} onClick={() => setShowCertLayer(true)}>인증/보안</span>
						</div>
						<div className={styles["setting-object"]}></div>
					</div>
				</div>
				<div className="shadow">
					<div className="padding">
						<div className="flex-justify_between align_center" onClick={() => setShowEventLayer(true)}>
							<div className="flex-align_center">
								<h3>이벤트</h3>
								{eventNewIcon && <span className={`${styles.badge} ml_5`}>N</span>}
							</div>
							{/* <Link to="event"> */}
							<i className="icon_arrow_sm icon_arrow_md right" />
							{/* </Link> */}
						</div>
						<span className={`${styles["title-guide"]} mt_20`}>진행중인 이벤트의 빵빵한 혜택<br />놓치지 않을거에요!</span>
						<Scroller
							dotsStyle={styles.dotsStyle}
							dotStyle={styles.dotStyle}
							activeDotStyle={styles.activeDotStyle}
							full={true}
						>
							{
								eventList && eventList.map((item, index) => {
									const start = Lib.ChanageNewDate(`${item.operStDe.replace(/\.|-/g, "/")} ${item.operStTm}`)
									const end = Lib.ChanageNewDate(`${item.operEdDe.replace(/\.|-/g, "/")} ${item.operEdTm}`)
									const now = new Date()
									if (end >= now && now >= start) {
										return (
											<li key={index} className="mt_10" onClick={() => onEventClick(item.sno)}>
												<div className="img-box" style={{ height: "12rem", borderRadius: "1rem" }}>
													<img src={`/api/comm/showImage/${item.sstmFileId}`} alt="" />
												</div>
											</li>
										)
									}
								})
							}
						</Scroller>
					</div>
				</div>
				<div className="shadow">
					<div className="padding">
						<h3>기타 서비스</h3>
						<div className={`${styles["service-menu"]} mt_30`}>
							<div className={styles.wrap}>
								<div onClick={() => setShowNoticeLayer(true)}>
									<span className={styles.serviceSpan}>
										<i className={`${styles["icon_service01"]} ${styles["icon_service"]} icon`} />
										<p>공지사항</p>
										{noticeNewIcon && <span className={styles.badge}>N</span>}
									</span>
								</div>
								<div onClick={() => setShowFaqLayerState(true)}>
									<span className={styles.serviceSpan}>
										<i className={`${styles["icon_service02"]} ${styles["icon_service"]} icon`} />
										<p>FAQ</p>
									</span>
								</div>
								<div onClick={() => setShowQuestionLayer(true)}>
									<span className={styles.serviceSpan}>
										<i className={`${styles["icon_service03"]} ${styles["icon_service"]} icon`} />
										<p>문의하기</p>
										{qnaNewIcon && <span className={styles.badge}>N</span>}
									</span>
								</div>
							</div>
							<div className={styles.wrap}>
								<div onClick={() => setShowAlarmLayerState(true)}>
									<span className={styles.serviceSpan}>
										<i className={`${styles["icon_service04"]} ${styles["icon_service"]} icon`} />
										<p>알림설정</p>
									</span>
								</div>
								<div onClick={() => setShowTermsAgreeLayerState(true)}>
									<span className={styles.serviceSpan}>
										<i className={`${styles["icon_service05"]} ${styles["icon_service"]} icon`} />
										<p>약관/동의</p>
									</span>
								</div>
								<div onClick={() => setShowAppVerLayerState(true)}>
									<span className={styles.serviceSpan}>
										<i className={`${styles["icon_service06"]} ${styles["icon_service"]} icon`} />
										<p>앱버전</p>
										{version && <span className={styles.badge}>N</span>}
									</span>
								</div>
							</div>
						</div>
					</div>
				</div>
				{/* <div className="padding">
					<h3>더 많은 정보를 확인해보세요!</h3>
					<div className={`${styles["service-menu"]} mt_30`}>
						<div className={styles.wrap}>
							<div onClick={() => openWebview("http://www.fintech1.co.kr/")}>
								<span className={styles.serviceSpan}>
									<i className="icon logo_fintech" />
									<p>핀테크</p>
								</span>
							</div>
							<div onClick={() => openWebview("https://www.moneey.co.kr/")}>
								<span className={styles.serviceSpan}>
									<i className="icon logo_moneey" />
									<p>모니</p>
								</span>
							</div>
							<div onClick={() => openWebview("https://www.youtube.com/channel/UC31e5ebNdoNga6qXH8CRdjw")}>
								<span className={styles.serviceSpan}>
									<i className="icon logo_youtube" />
									<p>유튜브</p>
								</span>
							</div>
						</div>
					</div>
				</div> */}
			</div>

			<MemberEditLayer />
			<EventLayer eventss={eventList} />
			<EventDetailLayer eventDetail={eventDetail} />
			<Notice />
			<Faq />
			<AlarmSetting />
			<AppVer />
			<CertLayer />
			<TermsAgree />
			<Question />
			<MemberOutReasonLayer />
		</Layer>
	)
}



export default SettingHome